import { useCssModule, provide, defineComponent, getCurrentInstance } from '@nuxtjs/composition-api';
import { presets } from '~/composables/grid/profile';
import { useDuck } from '~/services';
import { getArticlesSize } from '~/composables';
import { cachePage, useAsyncRef, createHead } from '~/utils';
/**
 * Duck service.
 */
const duck = useDuck();
const columns = {
    desktop: 2,
    desktopMedium: 2,
    desktopWide: 2,
    mobile: 1,
    mobileMedium: 1,
    mobileWide: 1,
    tablet: 2,
};
const entries = [
    { title: 'Forbes Club', to: '/club' },
    { title: 'Лица', to: '/club/faces' },
];
export default defineComponent({
    name: 'PageProfile',
    setup() {
        const css = useCssModule();
        /**
         * Instance.
         */
        const instance = getCurrentInstance();
        /**
         * Is person.
         */
        const isPerson = useAsyncRef(instance, 'isPerson');
        /**
         * Articles.
         */
        const articles = useAsyncRef(instance, 'articles');
        /**
         * Profile.
         */
        const profile = useAsyncRef(instance, 'profile');
        const pageOffset = useAsyncRef(instance, 'pageOffset');
        const isDone = useAsyncRef(instance, 'isDone');
        provide('articles', articles);
        provide('profile', profile);
        return {
            articles,
            columns,
            entries,
            css,
            isDone,
            isPerson,
            pageOffset,
            presets,
            profile,
        };
    },
    async asyncData(context) {
        const { app, env, error, redirect, req, res, route, query } = context;
        try {
            const routePath = route.path.replace(/^\/|\/$/g, '');
            const { data: profile } = await duck.pub.getPubArticleByAlias({
                url_alias: routePath,
            });
            const profilePath = profile?.url_alias || '';
            // If it's not a preview link
            if (!routePath.startsWith('preview')) {
                const withChangedUrl = profilePath.toLowerCase() !== routePath.toLowerCase();
                if (withChangedUrl) {
                    // Redirect profile with from old url
                    return redirect(301, `/${profilePath}`, query);
                }
            }
            // TODO Подобрать более подходящее название переменной. Возможно, будет отдельный диз для профиля города
            const isPerson = ['company', 'city', 'man', 'school'].includes(profile?.profile_type || '');
            const pageNumber = Number(route.query.page) || 0;
            const pageOffset = pageNumber > 0 ? pageNumber - 1 : 0;
            let articles = [];
            let isDone = false;
            if (!isPerson) {
                const limit = getArticlesSize(app.$viewport.breakpoint, {
                    columns,
                    presets,
                });
                const isFaceClubProfile = profile.profile_type === 'face_club';
                const { data } = await duck.pub.getPubArticles({
                    'list[limit]': limit,
                    'list[offset]': limit * pageOffset,
                    ...(!isFaceClubProfile && { 'node[authors]': String(profile.id) }),
                    ...(isFaceClubProfile && { 'node[face_club]': String(profile.id) }),
                });
                if (pageNumber && !data?.length) {
                    throw new Error('Not found');
                }
                if (data?.length < limit) {
                    isDone = true;
                }
                articles = data;
            }
            const { photo = {}, title = '', subtitle = '' } = profile || {};
            let description = `${title} – подробная информация о людях и компаниях — на Forbes.ru`;
            if (subtitle) {
                description = `${title} – ${subtitle}`;
            }
            const head = {
                canonical: env.HOST + route.path,
                description,
                image: (photo || {}).uri || '',
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            if (process.server) {
                const [firstArticle] = articles;
                if (firstArticle) {
                    const date = firstArticle.changed || firstArticle.time || firstArticle.created;
                    cachePage({ date, req, res });
                }
            }
            return {
                $page: context.$page,
                articles,
                head,
                isDone,
                isPerson,
                pageOffset,
                profile,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
